import { motion, AnimatePresence } from "framer-motion";

export default function Tag({ text }) {
  return (
    <div className="bg-beige text-[#FEFAF6] text-xs rounded-full px-3 py-1">
      <AnimatePresence mode='wait'>
        <motion.span
          key={text}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}>
          {text}
        </motion.span>
      </AnimatePresence>
    </div>
  );
}